
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 15","width":"15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#1A1A1A","d":"M14.2 2.2L12.8.8 7.5 6.1 2.2.8.8 2.2l5.3 5.3-5.3 5.3 1.4 1.4 5.3-5.3 5.3 5.3 1.4-1.4-5.3-5.3z"}})])
          )
        }
      }
    